import { getIntentValue, getSessionId } from '../components/SessionStorage';

const { constants } = require('./config/constants');
const rvpFlag = constants.rvp_flag;

const normalizeMobileInput = (value) => {
    const trimmed = String(value || '').trim();
    if (/^91\d{10}$/.test(trimmed)) {
        return trimmed.slice(2);
    }
    return trimmed;
};

const isMobileNumberInput = (value) => /^\d{10}$/.test(normalizeMobileInput(value));

export { normalizeMobileInput };

const resolveShipmentLookupEntity = (inputValue) => {
    const normalizedValue = normalizeMobileInput(inputValue);
    if (isMobileNumberInput(inputValue)) {
        return { name: 'mobile_number', value: normalizedValue };
    }
    return { name: 'shipment_mobile', value: inputValue };
};

export async function fetchHeaders (payload) {
    return {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'project': 'chatBot',
        },
        body: JSON.stringify(payload),
    };
}

export async function createOTPPayload (otp, mobileNo, options = {}) {
    const { getAWBValue } = require('../components/SessionStorage');
    const normalizedMobile = normalizeMobileInput(mobileNo);
    let payload = {
        "inputText": normalizedMobile,
        "languageCode": "en",
        "sessionId": getSessionId(),
        "intent": {
            "entities": [
                {
                    "name": "shipment_mobile",
                    "value": normalizedMobile,
                    "name_extra": "",
                    "value_extra": ""
                }
            ],
            "name": "fetch-otp",
            "mobileNumber" : normalizedMobile,
            "otp" : otp,
            "shipmentId": getAWBValue(),
            "otpPurpose": options.otpPurpose || "",
        },
        "payload": {
            "contexts": [],
            "params": null,
            "loadOrder": null,
            "slots": {}
        },
        "user": {
            "authKey": "111111"
        }
    }
    return payload;
}

export async function createStatusPayload (inputValue, intentName) {
    let flag = false;
    if (rvpFlag.includes(intentName))
        flag = true;

    const lookupEntity = resolveShipmentLookupEntity(inputValue);

    let payload = {
        "inputText": lookupEntity.value,
        "languageCode": "en",
        "sessionId": getSessionId(),
        "intent": {
            "entities": [
                {
                    "name": lookupEntity.name,
                    "value": lookupEntity.value,
                    "name_extra": "",
                    "value_extra": ""
                }
            ],
            "name": intentName,
            "rvp_flag" : flag
        },
        "payload": {
            "contexts": [],
            "params": null,
            "loadOrder": null,
            "slots": {}
        },
        "user": {
            "authKey": "111111"
        }
    };
    return payload;
}

export async function createIntentPayload (inputValue, typeAPI) {
    let payload = {
        "inputText": inputValue,
        "languageCode": "en",
        "sessionId": getSessionId(),
        "intent": {
            "entities": [
                {
                    "name": "type",
                    "value": inputValue,
                    "name_extra": "",
                    "value_extra": ""
                }
            ],
            "name": typeAPI
        },
        "payload": {
            "contexts": [],
            "params": null,
            "loadOrder": null,
            "slots": {}
        },
        "user": {
            "authKey": "111111"
        }
    };
    return payload;
}

export async function createOtpSendPayload(mobileNo, options = {}) {
    const { getAWBValue } = require('../components/SessionStorage');
    const normalizedMobile = normalizeMobileInput(mobileNo);
    return {
        inputText: normalizedMobile,
        languageCode: 'en',
        sessionId: getSessionId(),
        intent: {
            entities: [
                {
                    name: 'mobile_number',
                    value: normalizedMobile,
                    name_extra: '',
                    value_extra: '',
                },
            ],
            name: 'fetch-records-otp',
            mobileNumber: normalizedMobile,
            otpPurpose: options.otpPurpose || '',
        },
        payload: {
            contexts: [],
            params: null,
            loadOrder: null,
            slots: {},
        },
        user: {
            authKey: '111111',
            shipment_id: getAWBValue(),
        },
    };
}

export async function createPayload (typeValue, typeAPI) {
    const { getAWBValue, getNumber } = require('../components/SessionStorage');
    const sessionMobile = normalizeMobileInput(getNumber());
    let payload = {
        "inputText"  : "11",
        "languageCode": "en",
        "sessionId": getSessionId(),
        "intent": {
            "entities": [
                {
                    "name": "type",
                    "value": typeValue,
                    "name_extra": "",
                    "value_extra": "",
                }
            ],
            "name": typeAPI,
            ...(sessionMobile ? { mobileNumber: sessionMobile } : {}),
        },
        "payload": {
            "contexts": [],
            "params": null,
            "loadOrder": null,
            "slots": {}
        },
        "user": {
            "authKey": "111111",
            "shipment_id": getAWBValue()
        }
    };
    return payload;
}

export async function createRiderConcernPayload (awb, concernType, description, incidentDate) {
    let payload = {
        "inputText": awb,
        "languageCode": "en",
        "sessionId": getSessionId(),
        "intent": {
            "entities": [
                {
                    "name": "shipment_id",
                    "value": awb,
                    "name_extra": "rider-concern-type",
                    "value_extra": concernType || ""
                },
                {
                    "name": "rider-concern-description",
                    "value": description || "",
                    "name_extra": "rider-concern-description",
                    "value_extra": description || ""
                },
                {
                    "name": "rider-concern-date",
                    "value": incidentDate || "",
                    "name_extra": "rider-concern-date",
                    "value_extra": incidentDate || ""
                }
            ],
            "name": "rider-concern-ticket"
        },
        "payload": {
            "params": null,
            "contexts": [],
            "loadOrder": null,
            "slots": []
        },
        "user": {
            "authKey": "111111",
            "shipment_id": awb,
            "shipment_mobile": awb
        }
    };
    return payload;
}

export async function createTicketPayload (inputValue, ticket, name, value) {
    // validate-pincode / update-contact-number must use shipment_id (AWB), not shipment_mobile.
    const entityName = (
        name === 'update-contact-number' || ticket === 'validate-pincode'
    ) ? 'shipment_id' : 'shipment_mobile';
    
    let payload = {
        "inputText": inputValue,
        "languageCode": "en",
        "sessionId": getSessionId(),
        "intent": {
            "entities": [
                {
                    "name": entityName,
                    "value": inputValue,
                    "name_extra": name,
                    "value_extra": value
                }
            ],
            "name": ticket
        },
        "payload": {
            "params": null,
            "contexts": [
                {
                    "name": "ask-help",
                    "parameters": {
                        "qtype": ""
                    },
                    "lifespan": 1
                }
            ],
            "loadOrder": null,
            "slots": []
        },
        "user": {
            "authKey": "111111",
            "shipment_id": inputValue,
            "shipment_mobile": inputValue
        }
    };
    return payload;
}

export async function createAddressUpdatePayload(inputValue, pincode, address) {
    let payload = {
        "inputText": address,
        "languageCode": "en",
        "sessionId": getSessionId(),
        "intent": {
            "entities": [
                {
                    "name": "shipment_id",
                    "value": inputValue,
                    "name_extra": "pincode",
                    "value_extra": pincode
                },
                {
                    "name": "address",
                    "value": address,
                    "name_extra": "address",
                    "value_extra": address
                }
            ],
            "name": "update-contact-address-yes"
        },
        "payload": {
            "params": null,
            "contexts": [
                {
                    "name": "ask-help",
                    "parameters": {
                        "qtype": "update_contact_address"
                    },
                    "lifespan": 1
                }
            ],
            "loadOrder": null,
            "slots": []
        },
        "user": {
            "authKey": "111111",
            "shipment_id": inputValue,
            "shipment_mobile": inputValue,
            "update_address_pincode": pincode,
            "update_address_text": address
        }
    };
    return payload;
}

export async function createRequestPayload(mobileNo, operation, requestTicket, shippingId, requestButton, updatedNumber, futureDate, requestType) {
    try {
        let payload = {
            "inputText": "",
            "languageCode": "en",
            "sessionId": getSessionId(),
            "intent": {
                "entities": [
                    {
                        "name": "shipment_mobile",
                        "value": "",
                        "name_extra": "",
                        "value_extra": ""
                    }
                ],
                "name": "requests-insertion",
                "mobileNo": mobileNo,
                'operation': operation,
                'requestType': requestType, // Ticket type status, update, complaint
                'requestTicket': requestTicket,
                'shippingId' : shippingId,
                'requestButton' : requestButton,
                'updatedNumber' : updatedNumber,
                'futureDate' : futureDate
            },
            "payload": {
                "params": null,
                "contexts": [
                    {
                        "name": "ask-help",
                        "parameters": {
                            "qtype": ""
                        },
                        "lifespan": 1
                    }
                ],
                "loadOrder": null,
                "slots": []
            },
            "user": {
                "authKey": "111111"
            }
        };
        return payload;
    } catch (error) {
        console.log('error in createRequestPayload', error);
        return;
    }
}

// #features_pxb5559 changes done for future pickup and auto sent OTP
export async function createAwbDetailsPayload (shippingID) {
    let payload = {
        "inputText"  : "11",
        "languageCode": "en",
        "sessionId": getSessionId(),
        "intent": {
            "entities": [
                {
                    "name": "shipment_id",
                    "value": shippingID,
                    "name_extra": "",
                    "value_extra": "",
                }
            ],
            "name": "fetch-mobile-no",
        },
        "payload": {
            "contexts": [],
            "params": null,
            "loadOrder": null,
            "slots": {}
        },
        "user": {
            "authKey": "111111"
        }
    };
    return payload;
}

// #enhancements_pxb5559 changes done according workflow enhancements
export const getFutureDate = () => {
    let date = new Date();
    date.setDate(date.getDate() + 1);
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();
    return `${year}-${month}-${day}`;
}

export async function createDelayPayload(shippingID, ticket, nameExtra) {
    try {
        let rvpFlag = false;
        if (getIntentValue() === "131") {
            rvpFlag = true;
        }
        let delayDate = getFutureDate();
        let payload = {
            "inputText": "",
            "languageCode": "en",
            "sessionId": getSessionId(),
            "intent": {
                "entities": [
                    {
                        "name": "shipment_mobile",
                        "value": shippingID,
                        "name_extra": nameExtra,
                        "value_extra": delayDate
                    }
                ],
                "name": ticket,
                "rvp_flag" : rvpFlag
            },
            "payload": {
                "params": null,
                "contexts": [
                    {
                        "name": "ask-help",
                        "parameters": {
                            "qtype": ""
                        },
                        "lifespan": 1
                    }
                ],
                "loadOrder": null,
                "slots": []
            },
            "user": {
                "authKey": "111111"
            }
        };
        return payload;
    } catch (error) {
        console.log('error in createRequestPayload', error);
        return;
    }
}

export async function createSelectShippingIdPayload(shippingId) {
    let payload = {
        "inputText": shippingId,
        "languageCode": "en",
        "sessionId": getSessionId(),
        "intent": {
            "entities": [
                {
                    "name": "shipment_id",
                    "value": shippingId,
                    "name_extra": "",
                    "value_extra": ""
                }
            ],
            "name": "select-shipping-id",
            "shipmentId": shippingId
        },
        "payload": { "contexts": [], "params": null, "loadOrder": null, "slots": {} },
        "user": { "authKey": "111111" }
    };
    return payload;
}

export async function createShowStatusButtonsPayload(latestStatus, awb) {
    let payload = {
        "inputText": latestStatus,
        "languageCode": "en",
        "sessionId": getSessionId(),
        "intent": {
            "entities": [],
            "name": "show-status-buttons",
            "latestShipmentStatus": latestStatus,
            "shipmentId": awb
        },
        "payload": { "contexts": [], "params": null, "loadOrder": null, "slots": {} },
        "user": { "authKey": "111111" }
    };
    return payload;
}

export async function saveConversation(messages, meta = {}) {
    try {
        const payload = {
            sessionId: getSessionId(),
            shippingId: meta.shippingId || '',
            mobile_number: meta.mobile_number || '',
            messages,
        };
        await fetch(
            (require('./config/config').config.chatbotbackendapi).replace('/webhook', '/chat/save-conversation'),
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'project': 'chatBot',
                },
                body: JSON.stringify(payload),
            }
        );
    } catch (error) {
        console.error('[saveConversation] error:', error);
    }
}
